'use client';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { yaNative } from '@weberus/ui/utils/ya-native';

/*
 * 딥링크 서비스 상태
 * -https://docs.google.com/document/d/19CRP1eIQ8xMircS-OSQrAM7obGL3eCqBOUr1dxV1Jaw
 * -https://docs.google.com/spreadsheets/d/1cKMHOjpZxFUn8FtUWJacfNUVJ0W4w6KGKtQBc96B0w8 (구버전)
 */
const DeeplinkMap = [
  {
    path: '/',
    deeplink: 'yanoljamotel://home',
  },
  {
    path: '/sub-home/entertainment',
    deeplink: 'yanoljamotel://entertainment',
  },
  {
    path: '/sub-home/global',
    deeplink: 'yanoljamotel://gplace',
  },
  {
    path: '/sub-home/guesthouse',
    deeplink: 'yanoljamotel://guesthouse',
  },
  {
    path: '/sub-home/hotel',
    deeplink: 'yanoljamotel://hotel',
  },
  {
    path: '/sub-home/leisure',
    deeplink: 'yanoljamotel://leisure',
  },
  {
    path: '/sub-home/motel',
    deeplink: 'yanoljamotel://motel',
  },
  {
    path: '/sub-home/live',
    deeplink: 'yanoljamotel://live',
  },
  {
    path: '/sub-home/pension',
    deeplink: 'yanoljamotel://pension',
  },
  {
    path: '/sub-home/residence',
    deeplink: 'yanoljamotel://residence',
  },
  {
    path: '/sub-home/transportation',
    deeplink: 'yanoljamotel://transportation',
  },
];

export const WebViewDeeplinkRedirector = () => {
  const pathname = usePathname();

  useEffect(() => {
    const deeplink = DeeplinkMap.find((item) => item.path === pathname)?.deeplink;
    if (!deeplink) return;

    if (yaNative.isEnabled) {
      yaNative.deepLink({ link: deeplink, replaceMode: 'back' });
    }
  }, [pathname]);

  return null;
};
